'use client';

import { useEffect, useMemo } from 'react';

export const useEmbedResizer = () => {
    const observer = useMemo(() => {
        if (typeof window === 'undefined') {
            return null;
        }

        return new window.ResizeObserver((entry, observer) => {
            const body = entry[0];

            if (body) {
                const message = {
                    messageType: 'resize',
                    height: body.contentRect.height,
                };
                window.parent.postMessage(message, '*');
            }

            return observer;
        });
    }, []);

    useEffect(() => {
        if (observer && window.document.body) {
            observer.observe(window.document.body);

            return () => observer.disconnect();
        }
    }, []);
};
